import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { usePermissions } from './usePermissions';

/**
 * Hook para obter providers filtrados baseado em permissões de empresa
 */
export function useFilteredProviders() {
  const { providers } = useSelector((state) => state.providers);
  const { hasCompanyAccess, permissions } = usePermissions();

  const filteredProviders = useMemo(() => {
    if (!providers || providers.length === 0) return [];
    return providers.filter(provider => hasCompanyAccess(provider.id));
  }, [providers, permissions]);

  return filteredProviders;
}

